import { css } from '@emotion/core';
import { theme } from '@weave/theme';

export const containerStyle = css`
  height: auto;
  min-height: 40px;
  padding: ${theme.spacing(1)};
`;
